import React from 'react';
import { PageWithAuthorization } from '@homeproved/shared/feature-auth';
import { CompanyAboutPage, prefetch } from '@homeproved/com/feature-company';
import { PageShell } from '@homeproved/com/feature-page-shell';
import { useRouter } from 'next/router';
import {
  apiFactory,
  CompaniesApiFactory,
  getDehydratedState,
} from '@homeproved/shared/data-access';

export const About: PageWithAuthorization = () => {
  const router = useRouter();
  const { slug } = router.query;

  return (
    <PageShell tabsMenu>
      <CompanyAboutPage slug={slug as string} />
    </PageShell>
  );
};

export async function getServerSideProps({ locale, params: { slug } }) {
  let company = null;
  const api = apiFactory(locale, CompaniesApiFactory);
  await api
    .apiCompaniesCompanyGet(slug)
    .then((result) => {
      company = result;
    })
    .catch((error) => {
      console.log(error);
    });

  return {
    props: {
      dehydratedState: await getDehydratedState(prefetch.about(locale, slug)),
      ogImage: company?.data?.data?.lastSocialShare?.data?.original || '',
      meta: {
        title: 'meta.titles.companyAbout',
        description: 'meta.descriptions.companyAbout',
        variables: {
          '%COMPANY%': company?.data?.data?.name ?? '',
          '%COMPANY_INTRO%':
            company?.data?.data?.about?.replace('<p>', '').replace('</p>', '') ?? '',
        },
      },
    },
  };
}

export default About;
